import React from "react";
import {Avatar,Drawer,Input,Select,Button,Rate} from 'antd';
import {InfoCircleOutlined,CreditCardOutlined,FireOutlined,ToolOutlined,TagOutlined,CarOutlined,AppstoreOutlined,LineChartOutlined } from '@ant-design/icons';

const { Search } = Input;
const { Option } = Select;

function Profile(props) {

	const user = JSON.parse(localStorage.getItem('@@auth_user'));
    return (
    	<Drawer
	        width={300}
	        title="Perfil"
	        placement="right"
	        closable={true}
	        onClose={()=>props.setVisible(false)}
	        open={props.visible}>
	      {user?<div>
	      <div style={{textAlign:"center"}}>
	        <Avatar size={56}>{user.first_name.charAt(0)}{user.last_name.charAt(0)}</Avatar>
	      </div>

	      <div style={{textAlign:"center",marginTop:16}}>
	        {user.first_name} {user.last_name} {user.puesto} 
	      </div>
	       <div style={{textAlign:"center"}}>
	        {user.email}
	      </div>
	       <div style={{textAlign:"center",marginTop:32}}>
	      <Button  style={{width: 140}} type="primary" onClick={props.logOff}>
            Cerrar sesión
          </Button>
	     </div>
         </div>:null}
       </Drawer>

    );
}

export default Profile;

